import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { BaseModel } from "../Generics/BaseModel"
import { awardMemory } from "../Memory/Memory"
import { AwardEntity } from "./AwardEntity"

export class AwardManagerEntity extends BaseModel {
  id: number

  currentCount: number

  awardId: number

  customerId: number

  timeWon: number

  status: EEnableStatusType

  hasAwardToTake: boolean

  awardEntity?: AwardEntity

  constructor(data: Partial<AwardManagerEntity> = {}) {
    super()

    this.id = data.id ?? -1

    this.currentCount = data.currentCount ?? 0

    this.awardId = data.awardId ?? -1

    this.customerId = data.customerId || -1

    this.timeWon = data.timeWon ?? 0

    this.status = data.status ?? EEnableStatusType.Active

    this.hasAwardToTake = data.hasAwardToTake ?? false

    this.awardEntity =
      new AwardEntity(data.awardEntity) ?? (this.awardId !== -1 ? (awardMemory.findById(this.awardId) ?? null) : null)

    if (this.awardEntity) {
      this.awardEntity.awardManagerEntity = this
    }
  }

  public override beforeToJSON(): void | Promise<void> {
    this.awardEntity?.beforeToJSON()
  }
}
